import React from "react";
import LayoutMain from "../../components/Layout/Main/Main";
import LeftSidedImageCopyItemCollection from "../../Partials/LeftSidedImageCopyItem/collection";
import ProductMiniItemCollection from "../../Partials/ProductMiniItem/Collection";

const leftSidedImageCopyItemCollectionData = [
  {
    descriptionContent: (
      <>
        <p>
          <strong>Design Concept</strong>
        </p>
        <p>
          The Garden design stage is the detailing and development of the ideas
          discussed on-site into a design concept plan providing an overall
          image of the finished garden. Included is a plan view of the project,
          perspective sketches of key areas, material suggestions such as paving
          or tiling elements and finally suggestions for plant material. Each
          garden design concept package includes sample images of the proposed
          works and an estimate of cost to implement the design.
        </p>

        <p>
          <strong>Landscape Architecture</strong>
        </p>
        <p>
          If the proposed scope of works requires an Application to council, a
          qualified and experienced Landscape Architect will document the
          concept plans for construction and prepare the supporting
          documentation. A detailed quote with options is then prepared for your
          consideration.
        </p>
      </>
    ),
    image: "images/about1.jpg",
    title: "Design",
  },
];

const ProductMiniItemCollectionData = [
  {
    image: "images/contemporary-garden-oasis-4.jpg",
    title: "Consultation",
    url: "/consultation",
  },
  {
    image: "images/contemporary-garden-oasis.jpg",
    title: "Estimating",
    url: "/estimating",
  },
  {
    image: "images/contemporary-garden-oasis-2.jpg",
    title: "Construction",
    url: "/construction",
  },
  {
    image: "images/contemporary-garden-oasis-3.jpg",
    title: "Maintenance",
    url: "/maintenance",
  },
];

const PageDesign = () => {
  return (
    <LayoutMain>
      <section className="about-top">
        <div className="container-3">
          <LeftSidedImageCopyItemCollection
            data={leftSidedImageCopyItemCollectionData}
          />
        </div>
      </section>
      <section className=" pt-70 pb-120 pt-sm-30 pb-sm-40">
        <div className="container-3">
          <div className="row">
            <ProductMiniItemCollection data={ProductMiniItemCollectionData} />
          </div>
        </div>
      </section>
    </LayoutMain>
  );
};

export default PageDesign;
